<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <notifications></notifications>
    <div class="header bg-gradient-success py-7 py-lg-4 pt-lg-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Let's reset your password!</h1>
              <p  v-if="!resetkey"
                class="text-lead text-white"
              >Please enter valid email address where reset link will send to</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-header bg-transparent pb-5"></div>
            <div class="card-body px-lg-5 py-lg-2">
              <validation-observer ref="formValidator">
                <form role="form">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    v-if="!resetkey"
                    :rules="{required: true, email: true }"
                    prepend-icon="ni email-1"
                    placeholder="Email"
                    v-model="email"
                  ></base-input>
                  <div slot="inputs" v-if="resetkey && invalidkey">
                    <div class="text-center">
                      <span>Exception encountered. Try to reset again.</span>
                    </div>
                  </div>
                  <div class="text-center" v-if="resetkey && !invalidkey">
                    <span>
                      Account
                      <b>{{email}}</b>
                    </span>
                    <base-input
                      alternative
                      class="mb-3"
                      name="Password"
                      :rules="{required: true, min: 4}"
                      prepend-icon="ni ic_lock_open"
                      type="password"
                      placeholder="Password"
                      v-model="pwd"
                    ></base-input>
                  </div>
                  <div class="text-center">
                   
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      v-if="!invalidkey"
                      @click.prevent="onReset"
                    >Reset</base-button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { SendMail } from "../../services/mail";
import { resetpwd } from "../../services/mtmpl";
import { GeneratePwd, Encrypt } from "../../services/crypto";
import { Reset, UserIdByEmail, SendResetEmail, EmailByResetKey } from "../../services/user";
export default {
  components: { Loading },
  props: {
    resetkey: String,
  },
  data() {
    return {
      isLoading: false,
      pwd: "",
      email: "h.salamov@gmail.com",
      invalidkey: false,
    };
  },
  methods: {
    onReset() {
      let user = {};
      user.email = this.email;
      this.isLoading = true;
      this.notfound = false;
      if (this.resetkey) {
        const newpwd = Encrypt(this.pwd, null);
        user.resetkey = this.resetkey;
        user.pwd = newpwd.key;
        user.salt = newpwd.salt;
        Reset(user).then((response) => {
          this.isLoading = false;
          this.notifyVue("success", "Password has been changed successfully!");
          this.$router.push({ name: "Login" });
        });
      } else {
        UserIdByEmail(user).then((r1) => {
          if (r1.data.result.id !== null) {
            SendResetEmail(user).then((r2) => {
              this.isLoading = false;
              this.notifyVue(
                "success",
                "Recovery link has been sent to your email!"
              );
            });
          } else {
            this.isLoading = false;
            this.notifyVue("danger", "User was not found!");
          }
        });
      }
    },
  },
  mounted() {
    if (!this.resetkey) return;
    else this.invalidkey = false;
    this.isLoading = true;
    EmailByResetKey(this.resetkey).then((response) => {
      this.isLoading = false;
      if (response.data.result !== undefined) {
        this.email = response.data.result;
        this.invalidkey = false;
      } else {
        this.invalidkey = true;
      }
    });
  },
};
</script>